import Icon from 'assets/components/icon/Icon';
import { getLocales } from 'assets/locales/Locale';
import ObjectInfo from 'assets/templates/objectInfo/ObjectInfo';
import Sidebar from 'assets/templates/sidebar/Sidebar';
import { pick } from 'lodash';
import { ContractConsentBackendAcceptanceState, useContractConsentProvider } from '../ContractConsent.Hooks';

export default function ContractConsentInfo() {
  const { lang } = getLocales();
  const { selected, pageRouter, views, getTokenStatus, contractConsentAuditListApi } = useContractConsentProvider();

  const client = {
    customerName: selected?.customerName,
    customerEmail: selected?.customerEmail,
    customerPhoneNumber: selected?.customerPhoneNumber,
    resendType: selected?.type.toLocaleUpperCase(),
  };

  const prices = pick(
    selected,

    'salePriceCAD',
    'dealerCost',
    'administrationFeeCAD',
    'insurancePremiumCAD',
    'subfees',
    'contractConsentEnhancements'
  );

  const contract = {
    createdAt: selected?.createdAtUtc,
    modifiedAt: selected?.modifiedAtUtc,
    answeredAt: selected?.answeredAt,
    product: selected?.product?.name,
    dealer: selected?.dealer?.name,
    appNumber: selected?.contract?.appNumber,
    vin: selected?.vehicleVin,
  };

  const acceptanceStatus = {
    acceptance:
      selected?.isAccepted === null
        ? ContractConsentBackendAcceptanceState.PENDING
        : selected?.isAccepted
          ? ContractConsentBackendAcceptanceState.ACCEPTED
          : ContractConsentBackendAcceptanceState.REJECTED,
    token: getTokenStatus(selected),
    manuallyAccepted: selected?.acceptedByUserId !== null ? true : null,
    acceptedBy: selected?.acceptedByUserFullName,
    reasonForManualAcceptance: selected?.reasonForManualAcceptance,
    noteForManualAcceptance: selected?.noteForManualAcceptance,
    limitOfLiability: selected?.limitOfLiability,
  };

  return !selected
    ? null
    : views.info && (
        <Sidebar
          onClose={() => pageRouter.updateParams({})}
          icon={<Icon class="if-info" />}
          title={`${lang.consentNumber.toLocaleUpperCase()}:  ${selected?.id}`}
          content={
            <>
              <ObjectInfo object={contract} objectName={lang.info} />
              <ObjectInfo object={client} objectName={lang.client} />
              <ObjectInfo object={prices} objectName={lang.prices} />
              <ObjectInfo object={acceptanceStatus} objectName={lang.acceptanceStatus} />
              {contractConsentAuditListApi.payload?.data?.map((it, idx) => (
                <ObjectInfo
                  key={it.id}
                  object={it.toContractConsentAuditInfo()}
                  objectName={`${lang.logs} ${idx + 1}`}
                  disableTranslation
                />
              ))}
            </>
          }
        />
      );
}
